import {
	AVAILABLITY_LIST_GET_LIST,
    AVAILABLITY_LIST_GET_LIST_SUCCESS,
    AVAILABLITY_LIST_GET_LIST_ERROR,
    AVAILABLITY_LIST_GET_LIST_WITH_FILTER
} from '../actions';

const INIT_STATE = {
	allrooms:null,	
	rooms: null,
	roomdetails:null,	
    loading: false	
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case AVAILABLITY_LIST_GET_LIST:
			return { ...state, loading: false };

        case AVAILABLITY_LIST_GET_LIST_SUCCESS:  
        //console.log(action.payload)       ; 
			return { ...state, loading: true, allrooms:action.payload.rooms, rooms: action.payload.rooms,roomdetails:action.payload.roomdetails };

		case AVAILABLITY_LIST_GET_LIST_ERROR:
			return { ...state, loading: true, error: action.payload };
			default: return { ...state };
			
		case AVAILABLITY_LIST_GET_LIST_WITH_FILTER:
			console.log(action.payload);
			if (action.payload.startDate === '') {
				return { ...state, loading: true, rooms: action.payload.rooms,roomdetails:action.payload.roomdetails, filter: null };
			} else {			

				const filteredItems = state.allrooms.filter((item) =>
				//console.log(new Date(item["chatDateTime"]).getTime())
				new Date( item["date"]).getTime() >= new Date(action.payload.startDate).getTime() 
				);
					//item[action.payload.column] === action.payload.value);
				return {
					...state, loading: true, chats: filteredItems, filter: {
						startDate: action.payload.startDate
					}
				}
			}
	}
}
